import Cookies from "js-cookie";
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import {WebSocketHelper} from "@shared/helpers/web-socket.helper";

// Configure dayjs plugins
dayjs.extend(duration);
dayjs.extend(localizedFormat);

export const cookies = Cookies.withAttributes({expires: 365, secure: true});

export const websocket = new WebSocketHelper();

// Faz 1.0: character class içindeki `\.` gereksiz; çıkarıldı.
export const isValidEmail = (email: string) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);

export const isEmpty = (...values: any[]): boolean => values.every(value => !value)

export function formatDateFromNow(value: Date): string {
  const now = dayjs();
  const then = dayjs(value);
  const diff = dayjs.duration(now.diff(then));

  if (diff.asSeconds() < 60) {
    const s = Math.floor(diff.asSeconds());
    return s <= 0 ? "now" : `${s}s ago`;
  }
  if (diff.asMinutes() < 60) {
    return `${Math.floor(diff.asMinutes())} min ago`;
  }
  if (diff.asHours() < 24) {
    return `${Math.floor(diff.asHours())} hr ago`;
  }
  if (diff.asDays() < 30) {
    return `${Math.floor(diff.asDays())}d ago`;
  }
  if (diff.asMonths() < 12) {
    return `${Math.floor(diff.asMonths())}mo ago`;
  }
  return `${Math.floor(diff.asYears())}y ago`;
}

export function formatDate(value: Date): string {
  return dayjs(value).format('LL');
}

export function maskLast(str: string, count: number, maskChar: string = '*'): string {
  if (count <= 0) return str;
  if (count >= str.length) return maskChar.repeat(str.length);
  return str.slice(0, -count) + maskChar.repeat(count);
}

